/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Paymentinvoices1Inputs */

const zh_billing_paymentinvoices1 = /** @type {(inputs: Billing_Paymentinvoices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款与发票`)
};

const en_billing_paymentinvoices1 = /** @type {(inputs: Billing_Paymentinvoices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment & Invoices`)
};

const es_billing_paymentinvoices1 = /** @type {(inputs: Billing_Paymentinvoices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagos y facturas`)
};

/**
* | output |
* | --- |
* | "Payment & Invoices" |
*
* @param {Billing_Paymentinvoices1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_paymentinvoices1 = /** @type {((inputs?: Billing_Paymentinvoices1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Paymentinvoices1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_paymentinvoices1(inputs)
	if (locale === "en") return en_billing_paymentinvoices1(inputs)
	return es_billing_paymentinvoices1(inputs)
});
export { billing_paymentinvoices1 as "billing_paymentInvoices" }